import { render, staticRenderFns } from "../tags/tags.html?vue&type=template&id=2098beb5&scoped=true&external"
import script from "../tags/tags.js?vue&type=script&lang=js&external"
export * from "../tags/tags.js?vue&type=script&lang=js&external"
import style0 from "../tags/tags.css?vue&type=style&index=0&id=2098beb5&prod&scoped=true&lang=css&external"
import style1 from "./Tags.vue?vue&type=style&index=1&id=2098beb5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2098beb5",
  null
  
)

export default component.exports